import React from "react";
import PropTypes from "prop-types";
import { GlossaryProvider } from "@learningblocks/storybook-components";
import { Image } from "@learningblocks/shared-components";
import "../style.scss";

import GlossaryIcon from "@common/images/Glossary.svg";

const ENTER_KEY = 13;
/**
 * GlossaryOption :
 * - GlossaryOption for HexagonCard
 */
export function GlossaryOption(props) {
  const { onOpenGlossary } = React.useContext(GlossaryProvider.Context);

  // When clicking on the hint button in hexagon card,
  // get the title for the card and then remove the HTML tags if present and search in glossary
  const onClick = () => {
    onOpenGlossary(props.glossaryId);
  };

  const onKeyDown = (event) =>
    event.keyCode === ENTER_KEY && onOpenGlossary(props.glossaryId);

  return (
    <div
      role="button"
      tabIndex={props.tabIndex}
      onKeyDown={onKeyDown}
      onClick={onClick}
      className="hex_info"
      aria-label="More info"
    >
      <Image src={GlossaryIcon} alt="more info" />
    </div>
  );
}

GlossaryOption.propTypes = {
  /**
   * Callback for onClick/onKeyDown event
   */
  onSelect: PropTypes.func,
  /**
   * tabIndex
   */
  tabIndex: PropTypes.number,
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * the word which glossary should be fetched.
   */
  title: PropTypes.string,
};

GlossaryOption.defaultProps = {
  onSelect: undefined,
  className: "",
};
